'use strict';

/* homeherocta.js -- entry for home hero CTA click tracking; loaded with `defer` by homeHero.cshtml */

var homeHeroCta = require('./components/homeHeroCta');

homeHeroCta.init();
